import React, { useContext } from 'react';
import { Industry } from '@carbon/icons-react';
import { CustomizedTypography } from '@components/Customized';
import {
  CompanyInfoContext,
  CompanyInfoContextValue
} from '../context/CompanyInfoContext';
import { CompanyInfoDetailSection } from './styled';

const CompanyFactoryAddress: React.FunctionComponent = () => {
  const context = useContext<CompanyInfoContextValue | null>(
    CompanyInfoContext
  );

  if (!context) return null;

  const { partnerInfo } = context;
  const factoryAddress = partnerInfo?.factoryAddress ?? '';

  if (!factoryAddress) return null;

  return (
    <CompanyInfoDetailSection>
      <div className="data-row">
        <div className="row-title">
          <Industry size={20} />
          <CustomizedTypography>공장위치</CustomizedTypography>
        </div>
        {!factoryAddress ? (
          <CustomizedTypography className="no-data">
            아직 정보가 없습니다{' '}
          </CustomizedTypography>
        ) : (
          <CustomizedTypography className="row-value">
            {factoryAddress}
          </CustomizedTypography>
        )}
      </div>
    </CompanyInfoDetailSection>
  );
};

export default CompanyFactoryAddress;
